import * as i0 from '@angular/core';
import { Pipe, Directive, Input, NgModule } from '@angular/core';
import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber';
import * as i1 from '@angular/forms';

const phoneUtilInstance = PhoneNumberUtil.getInstance();
class PhoneNumberPipe {
    transform(value, region = null) {
        const strValue = value.toString();
        const pn = phoneUtilInstance.parseAndKeepRawInput(strValue, region ? region : 'CZ');
        return phoneUtilInstance.format(pn, PhoneNumberFormat.INTERNATIONAL);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: PhoneNumberPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.0.7", ngImport: i0, type: PhoneNumberPipe, name: "phoneNumber" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: PhoneNumberPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'phoneNumber',
                }]
        }] });

/**
 * Directive that adds phone number formatting using Google PhoneNumberLibrary functionality to the input (ngControl).
 */
class PhoneNumberInputDirective {
    constructor(elementRef, control) {
        this.elementRef = elementRef;
        this.control = control;
        // eslint-disable-next-line @angular-eslint/no-input-rename
        this.region = null;
        this.isEditing = false;
    }
    ngOnInit() {
        if (this.control) {
            // Respond to the changes of the value by formatting it.
            this.subscriptionValueChange = this.control.valueChanges.subscribe(() => {
                if (!this.isEditing) {
                    this.formatValue();
                }
            });
        }
        this.formatValue();
    }
    ngOnDestroy() {
        if (this.subscriptionValueChange) {
            this.subscriptionValueChange.unsubscribe();
        }
    }
    /**
     * Formats the value of the control. If the value is not passed in the actual value of the control is taken.
     * @param value The value to format.
     */
    formatValue(value) {
        if (this.control) {
            if (value === undefined) {
                value = this.control.value;
            }
            if (value) {
                // Formatting is done via PhoneNumberPipe. It could be done directly through phonenumber library.
                // This saves the code.
                const formatted = PhoneNumberPipe.prototype.transform(value.replace(/[^+0-9]/g, ''), this.region);
                if (formatted != this.control.value) {
                    this.control.control.setValue(formatted);
                }
            }
        }
    }
    /**
     * Input is entering editing mode. The input formatting is done only when not actively editing the data.
     */
    editStart() {
        this.isEditing = true;
    }
    /**
     * Input is leaving editing mode. The input formatting is done only when not actively editing the data.
     */
    editEnd() {
        this.isEditing = false;
        this.formatValue();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: PhoneNumberInputDirective, deps: [{ token: i0.ElementRef }, { token: i1.NgControl }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.0.7", type: PhoneNumberInputDirective, selector: "[phoneNumberInput]", inputs: { region: ["phoneNumberRegion", "region"] }, host: { listeners: { "focusin": "editStart()", "focusout": "editEnd()" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: PhoneNumberInputDirective, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: '[phoneNumberInput]',
                    // eslint-disable-next-line @angular-eslint/no-host-metadata-property
                    host: {
                        '(focusin)': 'editStart()',
                        '(focusout)': 'editEnd()',
                    },
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i1.NgControl }], propDecorators: { region: [{
                type: Input,
                args: ['phoneNumberRegion']
            }] } });

class PhoneNumberModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: PhoneNumberModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.0.7", ngImport: i0, type: PhoneNumberModule, declarations: [PhoneNumberPipe, PhoneNumberInputDirective], exports: [PhoneNumberPipe, PhoneNumberInputDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: PhoneNumberModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: PhoneNumberModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [PhoneNumberPipe, PhoneNumberInputDirective],
                    imports: [],
                    exports: [PhoneNumberPipe, PhoneNumberInputDirective],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { PhoneNumberInputDirective, PhoneNumberModule, PhoneNumberPipe };
